module.exports = __webpack_public_path__ + "img/gallina-traino.9a73c284.jpg";